import { Spinner } from '../Spinner';
import { IButtonProps } from './Button.model';
import { StyledButton } from './Button.styled';

const Button = ({
	primary,
	loading,
	disabled,
	children,
	...props
}: IButtonProps): JSX.Element => {
	return (
		<StyledButton disabled={loading || disabled} {...props} $primary={primary}>
			{loading ? <Spinner /> : children}
		</StyledButton>
	);
};

export { Button };
